import styled, { css } from 'styled-components'

export const Container = styled.section`
  ${props => props.active && css`
    max-width: ${props.maxWidth};
    width: 100%;
    margin: 0 auto;
  `}
`
